import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      // light: '#2d2d2d',
      main: '#013c40',
      // dark: '#002884',
      // contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
  typography: {
    h1: {
      fontSize: '3.5rem',
      fontWeight: '300',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: '300',
    },
    h3: {
      fontSize: '1.6rem',
    },
    h4: {
      fontSize: '1.2rem',
    },
    h5: {
      fontSize: '1rem',
    },
    h6: {
      fontSize: '1.5rem',
    },
    pageHeader: {
      fontSize: '2rem',
      fontWeight: '400',
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    pageSubHeader: {
      fontSize: '1rem',
      fontWeight: '400',
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    formHeader: {
      fontSize: '1.5rem',
      fontWeight: '400',
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          formHeader: 'div',
          pageHeader: 'div',
          pageSubHeader: 'div',
        },
      },
    },
  },
});

export default theme;
